<template>
  <div class="tw-relative" @click.stop>
    <button
      type="button"
      class="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-text-slate-600 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-white focus:tw-outline-none focus:tw-ring-0"
      @click.stop="toggle"
      ref="triggerEl"
    >
      <font-awesome-icon icon="cog" class="tw-h-4 tw-w-4" />
    </button>

    <teleport to="body">
      <div
        v-if="isOpen"
        class="tw-fixed tw-z-50"
        :style="menuStyle"
        @click.stop
      >
        <div
          class="tw-w-56 tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/90 tw-backdrop-blur tw-shadow-lg tw-shadow-slate-900/10"
          role="menu"
          ref="menuEl"
        >
          <div class="tw-py-1">
            <a
              class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline"
              :href="printBLUrl(container.id)"
              target="_blank"
              role="menuitem"
              @click="close"
            >
              <font-awesome-icon icon="print" class="tw-h-4 tw-w-4 tw-text-slate-500" />
              <span>Print BL</span>
            </a>

            <button
              v-if="container.isActive && !order.isExport && !isLand"
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline"
              role="menuitem"
              @click="onShowContainer"
            >
              <font-awesome-icon icon="eye" class="tw-h-4 tw-w-4 tw-text-slate-500" />
              <span>View Container Status</span>
            </button>

            <button
              v-if="!isLand"
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline"
              role="menuitem"
              @click="onEditContainerDetails"
            >
              <font-awesome-icon icon="pen" class="tw-h-4 tw-w-4 tw-text-slate-500" />
              <span>Edit Container Details</span>
            </button>

            <button
              v-else
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline"
              role="menuitem"
              @click="onEditFreightContent"
            >
              <font-awesome-icon icon="pen" class="tw-h-4 tw-w-4 tw-text-slate-500" />
              <span>Edit Freight Contents</span>
            </button>

            <button
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline"
              role="menuitem"
              @click="onToggleTripStatus"
            >
              <font-awesome-icon icon="route" class="tw-h-4 tw-w-4 tw-text-slate-500" />
              <span>View Trip Status</span>
            </button>

            <button
              v-if="!getIsContainerCancelled && (!container.trips || container.trips.length == 0)"
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline"
              role="menuitem"
              @click="onAddTrip"
            >
              <font-awesome-icon icon="plus" class="tw-h-4 tw-w-4 tw-text-slate-500" />
              <span>Add Trip</span>
            </button>

            <button
              v-if="!getIsContainerCancelled"
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-rose-700 hover:tw-bg-rose-50/80 tw-no-underline hover:tw-no-underline"
              role="menuitem"
              @click="onCancelContainer"
            >
              <font-awesome-icon icon="ban" class="tw-h-4 tw-w-4" />
              <span>Cancel container</span>
            </button>

            <button
              v-if="getIsContainerCancelled"
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline"
              role="menuitem"
              @click="onUncancelContainer"
            >
              <font-awesome-icon icon="rotate-left" class="tw-h-4 tw-w-4 tw-text-slate-500" />
              <span>Restore container</span>
            </button>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, type PropType } from 'vue';

export default defineComponent({
  data() {
    return {
      isOpen: false,
      menuTop: 0,
      menuLeft: 0,
    };
  },
  props: {
    container: {
      type: Object as PropType<any>,
    },
    order: {
      type: Object as PropType<any>,
    },
    containerIdx: {
      required: true,
    },
    isLand: Boolean,
    freightContentIdx: {
      required: false,
    },
    freightContent: Object,
  },
  mounted() {
    document.addEventListener('click', (this as any).onDocumentClick);
    document.addEventListener('keydown', (this as any).onKeydown);
    window.addEventListener('scroll', (this as any).onScroll, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', (this as any).onDocumentClick);
    document.removeEventListener('keydown', (this as any).onKeydown);
    window.removeEventListener('scroll', (this as any).onScroll, true);
  },
  computed: {
    getIsContainerCancelled(): boolean {
      return Boolean((this as any).container?.isCancelled);
    },
    menuStyle(): any {
      const vm = this as any;
      return {
        top: `${vm.menuTop}px`,
        left: `${vm.menuLeft}px`,
      };
    },
  },
  methods: {
    toggle() {
      const vm = this as any;
      vm.isOpen = !vm.isOpen;
      if (vm.isOpen) {
        nextTick(() => vm.updatePosition());
      }
    },
    close() {
      (this as any).isOpen = false;
    },
    onDocumentClick() {
      (this as any).isOpen = false;
    },
    onKeydown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        (this as any).isOpen = false;
      }
    },
    onScroll() {
      (this as any).isOpen = false;
    },
    updatePosition() {
      const vm = this as any;
      const trigger = vm.$refs && vm.$refs.triggerEl ? (vm.$refs.triggerEl as HTMLElement) : null;
      const menu = vm.$refs && vm.$refs.menuEl ? (vm.$refs.menuEl as HTMLElement) : null;
      if (!trigger) return;

      const rect = trigger.getBoundingClientRect();

      const menuWidth = menu ? menu.offsetWidth : 224;
      const menuHeight = menu ? menu.offsetHeight : 0;
      const gap = 8;

      let left = rect.right - menuWidth;
      left = Math.max(gap, Math.min(left, window.innerWidth - menuWidth - gap));

      let top = rect.bottom + gap;
      if (menuHeight && top + menuHeight > window.innerHeight - gap) {
        top = rect.top - gap - menuHeight;
      }
      top = Math.max(gap, top);

      vm.menuLeft = left;
      vm.menuTop = top;
    },
    printBLUrl(containerIdx: number | string) {
      return `/print/order/bl/${(this as any).order.id}/container/${containerIdx}`;
    },

    onShowContainer() {
      (this as any).isOpen = false;
      (this as any).toggleTripStatus((this as any).container.id);
    },
    onEditContainerDetails() {
      (this as any).isOpen = false;
      (this as any).editContainerDetails((this as any).containerIdx);
    },
    onEditFreightContent() {
      (this as any).isOpen = false;
      (this as any).editFreightContent((this as any).freightContentIdx);
    },
    onToggleTripStatus() {
      (this as any).isOpen = false;
      (this as any).toggleTripStatus((this as any).container.id);
    },
    onAddTrip() {
      (this as any).isOpen = false;
      (this as any).addEmptyTrip((this as any).order, (this as any).container);
    },
    onCancelContainer() {
      (this as any).isOpen = false;
      (this as any).$emit('cancelContainer', (this as any).container);
    },
    onUncancelContainer() {
      (this as any).isOpen = false;
      (this as any).$emit('uncancelContainer', (this as any).container);
    },

    showContainer(container: any) {
      (this as any).$emit('showContainer', container);
    },
    editContainerDetails(containerIdx: any) {
      (this as any).$emit('editContainerDetails', containerIdx);
    },
    editFreightContent(freightContentIdx: any) {
      (this as any).$emit('editFreightContent', freightContentIdx);
    },
    toggleTripStatus(containerIdx: any) {
      (this as any).$emit('toggleTripStatus', containerIdx);
    },
    addEmptyTrip(order, container) {
      (this as any).$emit('addEmptyTrip', order, container);
    },
  },
});
</script>
